import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tbox-shadow: 0 0 0 2px ", ";\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\talign-items: center;\n\tbackground: ", ";\n\tdisplay: flex;\n\tjustify-content: center;\n\toverflow: hidden;\n\tposition: relative;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled, ui } from '@wp-g2/styles';
export var AvatarView = styled.div(_templateObject(), ui.color.lightGray);
export var border = css(_templateObject2(), ui.color.white);